"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _qrcode = _interopRequireDefault(require("qrcode.react"));
var _excluded = ["certifyUrl"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var MyQRCode = function MyQRCode(props) {
  var certifyUrl = props.certifyUrl,
    other = _objectWithoutProperties(props, _excluded);
  console.log('certifyUrl', certifyUrl);
  if (certifyUrl) {
    return /*#__PURE__*/_react["default"].createElement(_qrcode["default"], _extends({
      value: certifyUrl // 生成二维码的内容
      ,
      size: 250 // 二维码的大小
      ,
      fgColor: "#000000" // 二维码的颜色
    }, other));
  } else {
    return null;
  }
};
var _default = exports["default"] = MyQRCode;